import React from "react";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import useDescriptions from "@micado-digital/react-shop/ProductDetail/hooks/useDescriptions";

import styles from "./Description.styles";

const Description = ({ lang }) => {
	const descriptions = useDescriptions({ lang, type: "standard" });
	const { description } = descriptions || {};
	const css = styles();

	if (!description) return <></>;

	return (
		<Typography
			className={clsx(css.description, "mco-shop-product-detail-description")}
			component="div"
			dangerouslySetInnerHTML={{ __html: description }}
		/>
	);
};

export default Description;
